import Typography from '@mui/material/Typography'
import React from 'react'
import { useTranslation } from 'react-i18next'

const RenderTabLabel = (label: string) => {
  const { t } = useTranslation()

  return (
    <Typography variant="button" textTransform="uppercase">
      {t(`participant.tabs.${label}`)}
    </Typography>
  )
}

export default RenderTabLabel
